<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <h4 class="mb-2">
          {{ $t("servers.webshops") }}
        </h4>
        <div class="items">
          <button
            v-for="webshop in webshops"
            :key="webshop.id"
            class="btn w-100 text-start"
            :class="[
              webshop.id === selectedWebshop?.id ? 'btn-primary' : 'btn-simple',
            ]"
            v-on:click="selectedWebshop = webshop"
          >
            {{ webshop.name }}
          </button>
          <button
            class="btn w-100 text-start"
            :class="!selectedWebshop?.id ? 'btn-primary' : 'btn-simple'"
            v-on:click="selectedWebshop = {}"
          >
            {{
              !selectedWebshop?.id && selectedWebshop?.name
                ? "+ " + selectedWebshop?.name
                : "+ new webshop"
            }}
          </button>
        </div>
        <h4 class="my-2">
          {{ $t("webshops.setting") }}
        </h4>
        <div class="items">
          <div class="items">
            <div
              class="btn w-100 btn-simple text-start"
              :class="[selectedSection === 'basics' ? 'btn-primary' : '']"
              v-on:click="selectedSection = 'basics'"
            >
              {{ $t("warehouses.basics") }}
            </div>
            <template v-if="selectedWebshop?.id">
              <div
                class="btn w-100 btn-simple text-start"
                :class="[selectedSection === 'delivery' ? 'btn-primary' : '']"
                v-on:click="selectedSection = 'delivery'"
              >
                {{ $t("order.delivery2") }}
              </div>
              <div
                class="btn w-100 btn-simple text-start"
                :class="[selectedSection === 'payment' ? 'btn-primary' : '']"
                v-on:click="selectedSection = 'payment'"
              >
                {{ $t("order.payment") }}
              </div>
            </template>
          </div>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-if="selectedWebshop">
      <section id="basics" v-if="selectedSection === 'basics'">
        <h2>
          {{ $t("webshops.webshopSettings") }}
        </h2>
        <h4>
          {{ $t("webshops.basics") }}
        </h4>
        <div class="row text-start custom-input whitebg-input mt-4">
          <div class="col-12 mb-3 mt-4">
            <label class="form-label bold-12 text-gray">
              {{ $t("webshops.saleChannelType") }}
            </label>
            <div class="group-options">
              <button
                v-for="option in saleChannelTypeOptions"
                :key="option.value"
                type="button"
                class="group-option"
                :class="{
                  active: Number(selectedWebshop?.type ?? 1) === option.value,
                }"
                @click="setType(option.value)"
              >
                <div class="group-option-icon">
                  <BaseIcon :name="option.icon" type="settings" />
                </div>
                <div class="group-option-content">
                  <span class="group-option-label">{{ option.label }}</span>
                  <span class="group-option-description">{{
                    option.description
                  }}</span>
                </div>
              </button>
            </div>
          </div>
          <div class="row mb-3">
            <div :class="basicCol('name')">
              <label class="form-label bold-12 text-gray">
                {{ $t("session.name") }}
              </label>
              <input
                type="text"
                class="form-control remove-padding"
                :placeholder="$t(`session.name`)"
                v-model="selectedWebshop.name"
              />
            </div>
            <div :class="basicCol('domain')" v-if="isWebshopType">
              <label class="form-label bold-12 text-gray">
                {{ $t("webshops.domain") }}
              </label>
              <v-select
                v-model="selectedWebshop.domain"
                :options="domains"
                label="domain"
                :placeholder="$t(`webshops.domain`)"
                :reduce="(o) => o.domain"
                :getOptionKey="(d) => d.id"
                :clearable="false"
                append-to-body
              />
            </div>
            <div :class="basicCol('slug')" v-if="isWebshopType">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.urlSlug")
              }}</label>
              <input
                type="text"
                class="form-control remove-padding"
                placeholder="w-hu"
                v-model="selectedWebshop.slug"
              />
            </div>
            <div :class="basicCol('currency')">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.currency")
              }}</label>
              <v-select
                v-model="selectedWebshop.currency_code"
                :options="enabledCurrencies"
                label="code"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.code"
                :getOptionKey="(c) => c.code"
                append-to-body
              />
            </div>
            <div :class="basicCol('company')">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.company")
              }}</label>
              <v-select
                v-model="selectedWebshop.company_id"
                :options="companies"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.id"
                append-to-body
              />
            </div>
            <div :class="basicCol('language')">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.language")
              }}</label>
              <v-select
                v-model="selectedWebshop.default_language_code"
                :options="languages"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.code"
                :getOptionKey="(c) => c.code"
                append-to-body
              />
            </div>
            <div :class="basicCol('email')">
              <label class="form-label bold-12 text-gray">{{
                $t("register.email")
              }}</label>
              <input
                type="email"
                class="form-control remove-padding"
                placeholder="info@myshop.com"
                v-model="selectedWebshop.email"
              />
            </div>
            <div :class="basicCol('phone')">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.phone")
              }}</label>
              <input
                type="tel"
                class="form-control remove-padding"
                placeholder="+101234567"
                v-model="selectedWebshop.phone"
              />
            </div>
            <div :class="basicCol('country')">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.storesInThisCountry")
              }}</label>
              <v-select
                v-model="selectedWebshop.country_id"
                :options="countries"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.id"
                append-to-body
              />
            </div>
            <div :class="basicCol('returnDuration')">
              <label class="form-label bold-12 text-gray">
                Allow return duration
              </label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="selectedWebshop.return_allowed_days"
                  step="1"
                  :min="1"
                  :disabled="!selectedWebshop.is_return"
                />
                <span>days</span>
              </div>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-1">
                <div class="d-flex flex-column mt-3">
                  <span class="regular-12 text-black">
                    Product return service
                  </span>
                  <span class="help-text">
                    Allow customers to return products through the portal.
                  </span>
                </div>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_return"
                  value="1"
                  id="ct-1"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-2">
                <div class="d-flex flex-column mt-3">
                  <span class="regular-12 text-black">
                    Product change service
                  </span>
                  <span class="help-text">
                    Allow customers to request product exchanges.
                  </span>
                </div>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_change"
                  value="1"
                  id="ct-2"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-3">
                <div class="d-flex flex-column mt-3">
                  <span class="regular-12 text-black">
                    International COD service
                  </span>
                  <span class="help-text">
                    Enable Cash on Delivery for international orders.
                  </span>
                </div>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_international_cod"
                  value="1"
                  id="ct-3"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3" v-if="isWebshopType">
              <label class="cstm-check d-flex" for="ct-6">
                <div class="d-flex flex-column mt-3">
                  <span class="regular-12 text-black">
                    Use default language
                  </span>
                  <span class="help-text">
                    Automatically select the default language if the customer's
                    language is not available.
                  </span>
                </div>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.use_default_language"
                  value="1"
                  id="ct-6"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3" v-if="isWebshopType">
              <label class="form-label bold-12 text-gray">
                {{ $t("webshops.supportedLanguages") }}
              </label>
              <div class="supported-languages d-flex flex-wrap gap-3">
                <label
                  class="cstm-check d-flex m-0"
                  v-for="lang in languages"
                  :key="lang.code"
                >
                  <div class="d-flex flex-column">
                    <span class="regular-12 text-black">
                      {{ lang.name }}
                    </span>
                  </div>
                  <input
                    type="checkbox"
                    :value="lang.code"
                    :checked="supportedLanguages.includes(lang.code)"
                    v-on:change="
                      toggleSupportedLanguage(lang.code, $event.target.checked)
                    "
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <span class="help-text">
                {{ $t("webshops.supportedLanguagesDesc") }}
              </span>
            </div>
            <div class="col-12 mb-3 mt-4" v-if="isWebshopType">
              <label class="form-label bold-12 text-gray">
                {{ $t("webshops.groupDeliveryMethods") }}
              </label>
              <div class="group-options">
                <button
                  v-for="option in deliveryGroupingOptions"
                  :key="option.value"
                  type="button"
                  class="group-option"
                  :class="{
                    active:
                      Number(selectedWebshop.is_group_delivery_methods) ===
                      option.value,
                  }"
                  @click="
                    selectedWebshop.is_group_delivery_methods = option.value
                  "
                >
                  <div class="group-option-icon">
                    <BaseIcon :name="option.icon" type="settings" />
                  </div>
                  <div class="group-option-content">
                    <span class="group-option-label">{{ option.label }}</span>
                    <span class="group-option-description">{{
                      option.description
                    }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3 d-grid justify-content-end me-4">
          <button
            type="submit"
            class="btn btn-type-2 btn-normal"
            :disabled="basicSaving"
            v-on:click="saveBasic"
          >
            <span>{{ $t("orderChange.save") }}</span>
          </button>
        </div>
        <hr class="my-4" />
        <div v-if="selectedWebshop?.id">
          <h4>{{ $t("webshops.warehouses") }}</h4>
          <div class="row">
            <div class="col-6">
              <h5>Delivery</h5>
              <draggable
                class="dragArea row custom-input pt-2"
                tag="ul"
                :list="selectedWebshop.deliveryWarehouses"
                :group="{ name: 'g1' }"
                item-key="id"
                v-bind="dragOptions"
                :forceFallback="true"
                :scroll="true"
                :scrollSensitivity="100"
              >
                <template #item="{ element, index }">
                  <li class="row">
                    <div class="col-3">{{ ordinal_suffix_of(index) }}</div>
                    <div class="col">{{ element.name }}</div>
                    <div class="col-auto">
                      <button
                        class="btn btn-transparent"
                        v-on:click="deleteWarehouse('delivery', element.id)"
                      >
                        <BaseIcon name="trash" />
                      </button>
                    </div>
                  </li>
                </template>
              </draggable>
              <div class="row align-items-end">
                <div class="col">
                  <label class="form-label bold-12 text-gray">{{
                    $t("webshops.warehouse")
                  }}</label>
                  <v-select
                    v-model="selectedDeliveryWebshop"
                    :options="deliveryWarehouseOptions"
                    label="name"
                    :placeholder="$t(`webshops.selectOne`)"
                    append-to-body
                  />
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-transparent"
                    v-on:click="addWarehouse('delivery')"
                  >
                    <BaseIcon name="add" />
                  </button>
                </div>
              </div>
            </div>
            <div class="col-6">
              <h5>Return</h5>
              <draggable
                class="dragArea row custom-input pt-2"
                tag="ul"
                :list="selectedWebshop.returnWarehouses"
                :group="{ name: 'g1' }"
                item-key="id"
                v-bind="dragOptions"
                :forceFallback="true"
                :scroll="true"
                :scrollSensitivity="100"
              >
                <template #item="{ element, index }">
                  <li class="row">
                    <div class="col-3">{{ ordinal_suffix_of(index) }}</div>
                    <div class="col">{{ element.name }}</div>
                    <div class="col-auto">
                      <button
                        class="btn btn-transparent"
                        v-on:click="deleteWarehouse('return', element.id)"
                      >
                        <BaseIcon name="trash" />
                      </button>
                    </div>
                  </li>
                </template>
              </draggable>
              <div class="row align-items-end">
                <div class="col">
                  <label class="form-label bold-12 text-gray">{{
                    $t("webshops.warehouse")
                  }}</label>
                  <v-select
                    v-model="selectedReturnWebshop"
                    :options="returnWarehouseOptions"
                    label="name"
                    :placeholder="$t(`webshops.selectOne`)"
                    append-to-body
                  />
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-transparent"
                    v-on:click="addWarehouse('return')"
                  >
                    <BaseIcon name="add" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-3 d-grid justify-content-end me-4">
            <button
              type="submit"
              class="btn btn-type-2 btn-normal"
              v-on:click="saveWarehouses"
            >
              <span>{{ $t("webshops.saveWarehouses") }}</span>
            </button>
          </div>
        </div>
      </section>

      <section
        id="delivery"
        class="mb-5"
        v-if="selectedSection === 'delivery' && selectedWebshop?.id"
      >
        <div class="row align-items-center mb-2">
          <div class="col">
            <h4>{{ $t("order.delivery2") }}</h4>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-no-r"
              :class="
                deliveryGrouping === 'method' ? 'btn-primary' : 'btn-secondary'
              "
              v-on:click="deliveryGrouping = 'method'"
            >
              <span>{{ $t("webshops.groupByMethod") }}</span>
            </button>
            <button
              type="button"
              class="btn btn-no-l"
              :class="
                deliveryGrouping === 'country' ? 'btn-primary' : 'btn-secondary'
              "
              v-on:click="deliveryGrouping = 'country'"
            >
              <span>{{ $t("webshops.groupByCountry") }}</span>
            </button>
          </div>
        </div>

        <template v-if="deliveryGrouping === 'method'">
          <div class="row align-items-center mb-1">
            <div class="col">
              <button
                v-for="(method, i) in deliveryMethodTabs"
                :key="method.id"
                type="button"
                class="btn btn-small tab-removable btn-main-method-list"
                :class="[
                  method.id == selectedDeliveryMethodId
                    ? 'btn-primary'
                    : 'btn-secondary',
                  i > 0 ? 'btn-no-l' : '',
                  i < deliveryMethodTabs.length - 1 ? 'btn-no-r' : '',
                ]"
                v-on:click="selectedDeliveryMethodId = method.id"
              >
                <span>{{ method.name }}</span>
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  v-on:click.stop="disableDeliveryMethod(method)"
                />
              </button>
              <button
                v-if="deliveryMethodOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small"
                v-on:click="openSelectionModal('deliveryMethod')"
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
            </div>
          </div>
          <div
            class="row align-items-center mb-3"
            v-if="selectedDeliveryMethod"
          >
            <div class="col">
              <span
                v-for="country in selectedDeliveryMethodCountries"
                :key="country.id"
                class="badge info me-1 mb-1 removable-badge"
              >
                {{ country.name }}
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  role="button"
                  v-on:click="
                    removeDeliveryCountry(selectedDeliveryMethod, country.id)
                  "
                />
              </span>
              <button
                v-if="deliveryCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                v-on:click="openSelectionModal('deliveryMethodCountry')"
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="row align-items-center mb-1">
            <div class="col">
              <button
                v-for="(country, i) in deliveryCountryTabList"
                :key="country.id"
                type="button"
                class="btn btn-small tab-removable btn-main-method-list"
                :class="[
                  country.id == selectedDeliveryCountryId
                    ? 'btn-primary'
                    : 'btn-secondary',
                  i > 0 ? 'btn-no-l' : '',
                  i < deliveryCountryTabList.length - 1 ? 'btn-no-r' : '',
                ]"
                v-on:click="selectedDeliveryCountryId = country.id"
              >
                <span>{{ country.name }}</span>
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  v-on:click.stop="disableDeliveryCountry(country.id)"
                />
              </button>
              <button
                v-if="deliveryNewCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                v-on:click="openSelectionModal('country')"
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
            </div>
          </div>
          <div
            class="row align-items-center mb-3"
            v-if="selectedDeliveryCountryId"
          >
            <div class="col">
              <span
                v-for="method in selectedDeliveryCountryMethods"
                :key="method.id"
                class="badge info me-1 mb-1 removable-badge"
              >
                {{ method.name }}
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  role="button"
                  v-on:click="
                    removeDeliveryCountry(method, selectedDeliveryCountryId)
                  "
                />
              </span>
              <button
                v-if="deliveryMethodForCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                v-on:click="openSelectionModal('deliveryMethodForCountry')"
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
            </div>
          </div>
        </template>

        <div
          v-for="section in deliveryLeafSections"
          :key="section.key"
          class="mb-3"
        >
          <div class="row align-items-center mb-1">
            <div class="col">
              <img
                v-if="section.logo"
                :src="section.logo"
                class="height-1rem me-2"
                alt=""
              />
              <b class="me-1">{{ section.label }}</b>
              <span class="badge info me-2" v-if="section.isAutomaticSelect">
                Auto select
              </span>
              <span class="regular-12 text-gray" v-if="section.typeName">
                {{ section.typeName }}
              </span>
            </div>
            <div class="col-auto">
              <template v-if="sectionApps(section).length > 0">
                <span class="regular-12 text-gray me-1">Provider:</span>
                <v-select
                  :model-value="sectionAppId(section)"
                  :options="sectionApps(section)"
                  label="name"
                  :reduce="(a) => a.id"
                  :clearable="false"
                  :placeholder="$t(`webshops.selectOne`)"
                  append-to-body
                  class="section-provider-select"
                  v-on:update:modelValue="
                    (appId) => setSectionProvider(section, appId)
                  "
                >
                  <template #selected-option="{ name, icon }">
                    <img
                      v-if="icon"
                      :src="methodLogoUrl(icon)"
                      class="height-1rem me-1"
                      alt=""
                    />
                    <span>{{ name }}</span>
                  </template>
                  <template #option="{ name, icon }">
                    <img
                      v-if="icon"
                      :src="methodLogoUrl(icon)"
                      class="height-1rem me-1"
                      alt=""
                    />
                    <span>{{ name }}</span>
                  </template>
                </v-select>
              </template>
              <label
                v-if="section.canAutoSelect"
                class="
                  cstm-check
                  d-flex
                  align-items-center
                  ms-3
                  auto-select-check
                "
                :for="'auto-select-' + section.key"
              >
                <input
                  type="checkbox"
                  :id="'auto-select-' + section.key"
                  :checked="sectionAutoSelect(section)"
                  v-on:change="toggleSectionAutoSelect(section)"
                />
                <span class="checkmark"></span>
                <span class="regular-12 text-black ms-1">
                  Allow auto select
                </span>
              </label>
            </div>
          </div>
          <OneByOneTable
            v-if="currencies && currencies.length > 0"
            :rows="sectionRows(section)"
            v-model:items="section.items"
            type="delivery"
            :empty-line="true"
            :show-add="false"
            :key="section.key + '-' + key"
            v-on:delete="(d) => deleteDeliveryPrice(d)"
            v-on:update:field="(d, e, f) => updateDeliveryPrice(d, e, f)"
            v-on:add:field="(e, f) => addDeliveryPrice(section, e, f)"
            :disabled="disabled"
            :noMinHeight="true"
          />
        </div>
      </section>
      <section
        id="payment"
        v-if="selectedSection === 'payment' && selectedWebshop?.id"
      >
        <div class="row align-items-center mb-2">
          <div class="col">
            <h4>{{ $t("order.payment") }}</h4>
          </div>
        </div>

        <div class="row align-items-center mb-1">
          <div class="col">
            <button
              v-for="(method, i) in paymentMethodTabs"
              :key="method.id"
              type="button"
              class="btn btn-small tab-removable btn-main-method-list"
              :class="[
                method.id == selectedPaymentMethodId
                  ? 'btn-primary'
                  : 'btn-secondary',
                i > 0 ? 'btn-no-l' : '',
                i < paymentMethodTabs.length - 1 ? 'btn-no-r' : '',
              ]"
              v-on:click="selectedPaymentMethodId = method.id"
            >
              <span>{{ method.name }}</span>
              <BaseIcon
                name="close-circle"
                class="remove-x"
                v-on:click.stop="disablePaymentMethod(method)"
              />
            </button>
            <button
              v-if="paymentMethodOptions.length > 0"
              type="button"
              class="btn btn-type-2 btn-small"
              v-on:click="openSelectionModal('paymentMethod')"
            >
              <BaseIcon name="add" class="height-1rem" />
            </button>
          </div>
        </div>

        <template v-if="payment.length > 0">
          <div class="table-responsive mt-3">
            <EditableTable
              v-model:rows="paymentRows"
              v-model:items="payment"
              :show-add="false"
              :show-del="false"
              type="payment"
            />
          </div>
          <div class="row mb-3 d-grid justify-content-end me-4">
            <button
              type="submit"
              class="btn btn-type-2 btn-normal"
              v-on:click="savePayment"
            >
              <span>{{ $t("orderChange.save") }}</span>
            </button>
          </div>
        </template>
        <hr class="my-4" />

        <h5>{{ $t("webshops.paymentPrices") }}</h5>
        <div
          v-for="section in paymentLeafSections"
          :key="section.key"
          class="mb-3"
        >
          <div class="row align-items-center mb-2">
            <div class="col-auto">
              <img
                :src="section.logo"
                class="height-1rem me-2"
                v-if="section.logo"
              />
            </div>
            <div class="col">
              <h5 class="mb-0">{{ section.label }}</h5>
            </div>
          </div>
          <OneByOneTable
            v-if="currencies && currencies.length > 0"
            :rows="paymentPriceRowsView"
            v-model:items="section.items"
            type="payment"
            :empty-line="true"
            :show-add="true"
            :key="section.key + '-' + key"
            v-on:delete="(d) => deletePaymentPrice(d)"
            v-on:update:field="(d, e, f) => updatePaymentPrice(d, e, f)"
            v-on:add:field="(e, f) => addPaymentPrice(section, e, f)"
            :disabled="disabled"
            :noMinHeight="true"
          />
        </div>
      </section>
      <ConfirmModal
        ref="deleteModal"
        :title="$t(`webshops.deletePriceTitle`)"
        :text="`<ul><li>You will delete a price of this sale channel<b></li><li>You can't undo this action</li></ul><p>Are you sure you want to delete?</p>`"
        cancel-button="No, keep the price"
        ok-button="Yes, delete the price"
        v-on:success="deletePrice"
      />
      <div
        ref="selectionModal"
        class="modal fade"
        tabindex="-1"
        aria-hidden="true"
      >
        <div
          class="
            modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg
          "
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{
                  selectionType === "country"
                    ? $t("webshops.selectCountry")
                    : $t("webshops.selectMethod")
                }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body p-0">
              <div class="p-3 border-bottom sticky-top bg-white">
                <div class="input-group mb-2">
                  <span class="input-group-text bg-light border-end-0">
                    <BaseIcon name="search" class="height-1rem text-muted" />
                  </span>
                  <input
                    type="text"
                    class="form-control border-start-0 ps-0"
                    :placeholder="$t('webshops.search')"
                    v-model="selectionSearch"
                    ref="selectionSearchInput"
                  />
                </div>
                <div
                  class="d-flex flex-wrap gap-2 mt-2"
                  v-if="
                    Array.isArray(activeSelectionFilters) &&
                    activeSelectionFilters.length > 0
                  "
                >
                  <button
                    class="btn btn-sm py-1 px-3 rounded-pill"
                    :class="
                      selectionTypeFilter === null
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectionTypeFilter = null"
                  >
                    All
                  </button>
                  <button
                    v-for="filter in activeSelectionFilters"
                    :key="filter.id"
                    class="btn btn-sm py-1 px-3 rounded-pill"
                    :class="
                      filter && selectionTypeFilter === filter.id
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectionTypeFilter = filter.id"
                  >
                    {{ filter ? filter.name : "" }}
                  </button>
                </div>
              </div>
              <div class="selection-list">
                <div
                  v-for="item in filteredSelectionOptions"
                  :key="item.id"
                  class="
                    selection-item
                    d-flex
                    align-items-start
                    p-3
                    border-bottom
                  "
                  role="button"
                  v-on:click="selectItem(item)"
                >
                  <div class="selection-item-icon me-3 mt-1">
                    <img
                      v-if="item.logo || item.icon"
                      :src="methodLogoUrl(item.logo || item.icon)"
                      class="method-logo-lg"
                    />
                    <div
                      v-else-if="
                        selectionType == 'deliveryMethodCountry' && item?.code
                      "
                    >
                      <BaseIcon
                        :name="item?.code?.toLowerCase()"
                        type="flag"
                        class="flag"
                      />
                    </div>
                    <div v-else class="method-logo-placeholder">
                      {{ (item.name || item.code || "?").charAt(0) }}
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                      <span class="fw-bold">{{ item.name }}</span>
                      <span
                        v-if="item && item.type"
                        class="badge bg-light text-dark border fw-normal"
                      >
                        {{ $t(`webshops.deliveryTypes.${item.type}`) }}
                      </span>
                    </div>

                    <div
                      v-if="
                        (item.app_name && item.app_name !== 'null') ||
                        selectionType == 'deliveryMethod'
                      "
                    >
                      <span class="fw-medium">Provider:</span>
                      <template v-if="selectionType == 'deliveryMethod'">
                        <div class="d-flex flex-wrap gap-2 mt-1">
                          <div
                            v-for="provider in this.deliveryApps[item.id]"
                            :key="provider.id"
                            class="
                              d-flex
                              align-items-center
                              bg-light
                              rounded
                              px-2
                              py-1
                              border
                            "
                          >
                            <img
                              v-if="provider.icon"
                              :src="methodLogoUrl(provider.icon)"
                              class="method-logo-sm me-1"
                            />
                            <span class="small">{{
                              provider.app_name || provider.name
                            }}</span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        {{ item.app_name }}
                      </template>
                    </div>

                    <!-- Payment specific info -->
                    <div v-if="selectionType === 'paymentMethod'" class="mt-2">
                      <!-- Features -->
                      <div class="d-flex flex-wrap gap-1 mb-2">
                        <span
                          v-if="item.only_same_country"
                          class="
                            badge
                            bg-info-subtle
                            text-info
                            border-info-subtle
                            fw-normal
                          "
                        >
                          Only if the origin and destination country is the same
                        </span>
                        <span
                          v-if="item.only_official_currency"
                          class="
                            badge
                            bg-info-subtle
                            text-info
                            border-info-subtle
                            fw-normal
                          "
                        >
                          In the destination coutry's official currency only
                        </span>
                      </div>

                      <!-- Currencies -->
                      <div
                        v-if="
                          item.supported_currencies &&
                          item.supported_currencies.length
                        "
                        class="d-flex flex-wrap gap-1 align-items-center mb-1"
                      >
                        <span class="small text-muted me-1">Currencies:</span>
                        <span
                          v-for="currency in item.supported_currencies"
                          :key="currency"
                          class="badge bg-light text-secondary border fw-normal"
                        >
                          {{ currency }}
                        </span>
                      </div>

                      <!-- Countries -->
                      <div
                        v-if="
                          item.supported_countries &&
                          item.supported_countries.length
                        "
                        class="d-flex flex-wrap gap-1 align-items-center"
                      >
                        <span class="small text-muted me-1">Countries:</span>
                        <span
                          v-for="countryCode in item.supported_countries"
                          :key="countryCode"
                          class="badge bg-light text-secondary border fw-normal"
                        >
                          {{ countryCode }}
                        </span>
                      </div>
                    </div>

                    <!-- Delivery specific info -->
                    <div
                      v-if="
                        selectionType.includes('deliveryMethod') ||
                        selectionType === 'deliveryMethodForCountry'
                      "
                      class="mt-2"
                    >
                      <!-- Features -->
                      <div class="d-flex flex-wrap gap-1 mb-2">
                        <span
                          v-if="item.is_cod"
                          class="
                            badge
                            bg-success-subtle
                            text-success
                            border-success-subtle
                            fw-normal
                          "
                        >
                          COD
                        </span>
                        <span
                          v-if="item.is_delivery"
                          class="
                            badge
                            bg-info-subtle
                            text-info
                            border-info-subtle
                            fw-normal
                          "
                        >
                          Delivery
                        </span>
                        <span
                          v-if="item.is_return"
                          class="
                            badge
                            bg-warning-subtle
                            text-warning
                            border-warning-subtle
                            fw-normal
                          "
                        >
                          Return
                        </span>
                        <span
                          v-if="item.is_change"
                          class="
                            badge
                            bg-danger-subtle
                            text-danger
                            border-danger-subtle
                            fw-normal
                          "
                        >
                          Change
                        </span>
                      </div>

                      <!-- Countries -->
                      <div
                        v-if="
                          item.supported_coutries &&
                          item.supported_coutries.length
                        "
                        class="d-flex flex-wrap gap-1 align-items-center"
                      >
                        <span class="small text-muted me-1"
                          >Supported countries:</span
                        >
                        <span
                          v-for="countryCode in item.supported_coutries.slice(
                            0,
                            15
                          )"
                          :key="countryCode"
                          class="badge bg-light text-secondary border fw-normal"
                        >
                          {{ countryCode }}
                        </span>
                        <span
                          v-if="item.supported_coutries.length > 15"
                          class="small text-muted"
                        >
                          +{{ item.supported_coutries.length - 15 }} more
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="ms-3 mt-1">
                    <BaseIcon
                      name="chevron-forward"
                      class="height-1rem text-muted"
                    />
                  </div>
                </div>
                <div
                  v-if="filteredSelectionOptions.length === 0"
                  class="p-5 text-center text-muted"
                >
                  No results found
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OneByOneTable from "../lists/OneByOneTable";
import http from "@/modules/http";
import tenant from "@/modules/tenant";
import { useStore } from "vuex";
import draggable from "vuedraggable";
import BaseIcon from "../icons/BaseIcon.vue";
import ConfirmModal from "@/components/modals/ConfirmModal";

const deliveryTypeValues = {
  1: { id: 1, name: "Normal delivery" },
  2: { id: 2, name: "Pick-up point" },
  3: { id: 3, name: "Return" },
  4: { id: 4, name: "Change" },
  5: { id: 5, name: "Next day delivery" },
  6: { id: 6, name: "Saturday delivery" },
  7: { id: 7, name: "Flexible day delivery" },
  8: { id: 8, name: "Timeslot delivery" },
  9: { id: 9, name: "Drop off return" },
};

export default {
  name: "webshops",
  components: { BaseIcon, OneByOneTable, draggable, ConfirmModal },
  data() {
    return {
      store: useStore(),
      webshops: [],
      companies: [],
      domains: [],
      selectedWebshop: undefined,
      key: 0,
      disabled: false,
      basicSaving: false,
      deliveryGrouping: "method",
      selectedDeliveryMethodId: null,
      selectedDeliveryCountryId: null,
      deliveryMethodToAdd: null,
      deliveryCountryToAdd: null,
      deliveryNewCountryToAdd: null,
      deliveryMethodForCountryToAdd: null,
      deliveryAdder: null,
      deliverySaving: false,
      deliverySaveQueued: false,
      selectedSection: "basics",
      paymentGrouping: "method",
      selectedPaymentMethodId: null,
      selectedPaymentCountryId: null,
      paymentAdder: null,
      paymentMethodToAdd: null,
      paymentCountryToAdd: null,
      paymentNewCountryToAdd: null,
      paymentMethodForCountryToAdd: null,
      deliveryPrices: [],
      paymentPrices: [],
      loadInProcess: false,
      deleteItem: null,
      deleteType: null,
      selectionSearch: "",
      selectionType: null, // 'country', 'deliveryMethod', 'paymentMethod'
      selectionTypeFilter: null,
      selectionModal: null,
      paymentRows: [
        {
          name: "Name",
          key: "name",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Provider",
          key: "app_name",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Type",
          key: "type",
          type: "enum",
          label: "name",
          values: {
            1: { id: 1, name: "Prepaid" },
            2: { id: 2, name: "Payment on delivery" },
            3: { id: 3, name: "Cash" },
            4: { id: 4, name: "Bank transfer" },
            5: { id: 5, name: "Card on shop" },
          },
          editable: false,
          show: true,
        },
        {
          name: "Active",
          key: "active",
          type: "boolean",
          show: true,
        },
      ],
      payment: [],
      payments: [],
      deliveries: [],
      delivery: [],
      deliveryApps: {},
      paymentApps: {},
      deliveryPriceRows: [
        {
          name: "Currency",
          key: "currency_code",
          type: "enum",
          values: [],
          label: "code",
          selectKey: "code",
          show: true,
        },
        {
          name: "Price",
          key: "price",
          type: "number",
          show: true,
        },
        {
          name: "Min order amount",
          key: "min_order_amount",
          type: "number",
          show: true,
        },
        {
          name: "Min ordered item count",
          key: "min_order_count",
          type: "number",
          show: true,
        },
        {
          name: "Warehouse restriction",
          key: "warehouse_id",
          type: "enum",
          values: [],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "Pickup point type restriction",
          key: "delivery_point_type",
          type: "enum",
          values: [
            { id: null, name: " - " },
            { id: 1, name: "Pick-up point" },
            { id: 2, name: "Post office" },
            { id: 3, name: "Parcel automate" },
          ],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "In delivery",
          key: "is_delivery",
          type: "boolean",
          show: true,
          disabled_row: "has_delivery",
        },
        {
          name: "In return",
          key: "is_return",
          type: "boolean",
          show: true,
          disabled_row: "has_return",
        },
      ],
      paymentPriceRows: [
        {
          name: "Currency",
          key: "currency_code",
          type: "enum",
          values: [],
          label: "code",
          selectKey: "code",
          show: true,
        },
        {
          name: "Price",
          key: "price",
          type: "number",
          show: true,
        },
        {
          name: "Min order amount",
          key: "min_order_amount",
          type: "number",
          show: true,
        },
        {
          name: "Min ordered item count",
          key: "min_order_count",
          type: "number",
          show: true,
        },
        {
          name: "Warehouse restriction",
          key: "warehouse_id",
          type: "enum",
          values: [],
          label: "name",
          selectKey: "id",
          show: true,
        },
      ],
      selectedDeliveryWebshop: null,
      selectedReturnWebshop: null,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      deliveryGroupingOptions: [
        {
          value: 0,
          label: this.$t("webshops.groupNormalLabel"),
          description: this.$t("webshops.groupNormalDesc"),
          icon: "list-delivery-methods",
        },
        {
          value: 1,
          label: this.$t("webshops.groupEnabledLabel"),
          description: this.$t("webshops.groupEnabledDesc"),
          icon: "group-delivery-methods",
        },
      ],
      saleChannelTypeOptions: [
        {
          value: 5,
          label: this.$t("webshops.typeInternalLabel"),
          description: this.$t("webshops.typeInternalDesc"),
          icon: "puzzle",
        },
        {
          value: 1,
          label: this.$t("webshops.typeWebshopLabel"),
          description: this.$t("webshops.typeWebshopDesc"),
          icon: "shopping",
        },
        {
          value: 3,
          label: this.$t("webshops.typeMarketplaceLabel"),
          description: this.$t("webshops.typeMarketplaceDesc"),
          icon: "briefcase",
        },
      ],
      deliveryTypeOptions: [
        {
          value: "home",
          label: "Home Delivery",
          description: "Delivery to the customer's address.",
          icon: "home",
        },
        {
          value: "pickup",
          label: "Pick up",
          description: "Pick up at a point or locker.",
          icon: "location",
        },
        {
          value: "express",
          label: "Express",
          description: "Fast delivery or same day.",
          icon: "lightning",
        },
      ],
      selectedDeliveryType: "home",
      columnNumbers: [
        this.$t("serialNumbers.first"),
        this.$t("serialNumbers.second"),
        this.$t("serialNumbers.third"),
        this.$t("serialNumbers.fourth"),
        this.$t("serialNumbers.fifth"),
        this.$t("serialNumbers.sixth"),
        this.$t("serialNumbers.seventh"),
        this.$t("serialNumbers.eighth"),
        this.$t("serialNumbers.ninth"),
        this.$t("serialNumbers.tenth"),
      ],
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    hasMultipleActiveWarehouses() {
      const webshop = this.selectedWebshop;
      if (!webshop) {
        return false;
      }
      const ids = [];
      for (const w of webshop.deliveryWarehouses ?? []) {
        ids.push(w.id);
      }
      for (const w of webshop.returnWarehouses ?? []) {
        if (!ids.some((id) => id == w.id)) {
          ids.push(w.id);
        }
      }
      return ids.length > 1;
    },
    deliveryWarehouseOptions() {
      const used = this.selectedWebshop?.deliveryWarehouses ?? [];
      return this.warehouses.filter((w) => !used.some((u) => u.id == w.id));
    },
    returnWarehouseOptions() {
      const used = this.selectedWebshop?.returnWarehouses ?? [];
      return this.warehouses.filter((w) => !used.some((u) => u.id == w.id));
    },
    enabledCurrencies() {
      return this.store.state.currencies;
    },
    currencies() {
      return this.store.state.currencies || [];
    },
    isWebshopType() {
      return Number(this.selectedWebshop?.type ?? 1) === 1;
    },
    supportedLanguages() {
      return this.parseLanguages(this.selectedWebshop?.supported_languages);
    },
    languages() {
      return this.store.state.languages;
    },
    countries() {
      return this.store.state.countries;
    },
    deliveryMethodTabs() {
      if (!Array.isArray(this.delivery)) return [];
      return this.delivery.filter((m) => m.active);
    },
    deliveryMethodOptions() {
      if (!Array.isArray(this.delivery)) return [];
      return this.delivery.filter((m) => !m.active);
    },
    selectedDeliveryMethod() {
      return (
        this.delivery.find((m) => m.id == this.selectedDeliveryMethodId) ?? null
      );
    },
    selectedDeliveryMethodCountries() {
      const active = this.selectedDeliveryMethod?.countries?.active ?? [];
      return this.countries.filter((c) => active.some((id) => id == c.id));
    },
    deliveryCountryOptions() {
      const method = this.selectedDeliveryMethod;
      if (!method) {
        return [];
      }
      const supported = method.countries?.all;
      return this.countries.filter(
        (c) =>
          !method.countries.active.some((id) => id == c.id) &&
          (!supported ||
            !Array.isArray(supported) ||
            supported.some(
              (code) =>
                String(code).toUpperCase() === String(c.code).toUpperCase()
            ))
      );
    },
    deliveryCountryTabs() {
      const tabs = [];
      for (const method of this.delivery) {
        if (!method.active) {
          continue;
        }
        for (const countryId of method.countries?.active ?? []) {
          if (tabs.some((c) => c.id == countryId)) {
            continue;
          }
          const country = this.countries.find((c) => c.id == countryId);
          if (country) {
            tabs.push(country);
          }
        }
      }
      return tabs;
    },
    deliveryCountryTabList() {
      const tabs = [...this.deliveryCountryTabs];
      if (
        this.selectedDeliveryCountryId &&
        !tabs.some((c) => c.id == this.selectedDeliveryCountryId)
      ) {
        const pending = this.countries.find(
          (c) => c.id == this.selectedDeliveryCountryId
        );
        if (pending) {
          tabs.push(pending);
        }
      }
      return tabs;
    },
    deliveryNewCountryOptions() {
      return this.countries.filter(
        (c) => !this.deliveryCountryTabs.some((t) => t.id == c.id)
      );
    },
    selectedDeliveryCountryMethods() {
      return this.deliveryMethodTabs.filter((m) =>
        (m.countries?.active ?? []).some(
          (id) => id == this.selectedDeliveryCountryId
        )
      );
    },
    deliveryMethodForCountryOptions() {
      const country = this.countries.find(
        (c) => c.id == this.selectedDeliveryCountryId
      );
      if (!country) return [];
      const countryCode = String(country.code).toUpperCase();

      return this.delivery.filter(
        (m) =>
          !(m.countries?.active ?? []).some(
            (id) => id == this.selectedDeliveryCountryId
          ) &&
          (!m.supported_coutries ||
            !Array.isArray(m.supported_coutries) ||
            m.supported_coutries.some(
              (code) => String(code).toUpperCase() === countryCode
            ))
      );
    },
    deliveryLeafSections() {
      const sections = [];
      if (this.deliveryGrouping === "method") {
        const method = this.selectedDeliveryMethod;
        if (!method?.active) {
          return sections;
        }
        const activeCountries = method.countries?.active ?? [];
        if (activeCountries.length === 0) {
          sections.push(
            this.buildDeliverySection(method, { id: null }, method.name)
          );
        } else {
          for (const countryId of activeCountries) {
            const country = this.countries.find((c) => c.id == countryId) ?? {
              id: countryId,
            };
            sections.push(
              this.buildDeliverySection(
                method,
                country,
                country.name ?? "#" + country.id
              )
            );
          }
        }
      } else {
        if (!this.selectedDeliveryCountryId) {
          return sections;
        }
        const country = this.countries.find(
          (c) => c.id == this.selectedDeliveryCountryId
        ) ?? { id: this.selectedDeliveryCountryId };
        for (const method of this.selectedDeliveryCountryMethods) {
          sections.push(
            this.buildDeliverySection(method, country, method.name)
          );
        }
      }
      return sections;
    },
    paymentMethodTabs() {
      if (!Array.isArray(this.payment)) return [];
      return this.payment.filter((m) => m.active);
    },
    paymentMethodOptions() {
      if (!Array.isArray(this.payment)) return [];
      const activeDeliveryMethodIds = this.deliveryMethodTabs.map((m) => m.id);
      return this.payment
        .filter((m) => {
          if (m.active) return false;
          if (
            m.delivery_method_id !== undefined &&
            m.delivery_method_id !== null
          ) {
            return activeDeliveryMethodIds.includes(m.delivery_method_id);
          }
          return true;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    selectedPaymentMethod() {
      return (
        this.payment.find((m) => m.id == this.selectedPaymentMethodId) ?? null
      );
    },
    paymentLeafSections() {
      const sections = [];
      for (const method of this.paymentMethodTabs) {
        if (method.id == this.selectedPaymentMethodId) {
          sections.push(this.buildPaymentSection(method, method.name));
        }
      }
      return sections;
    },
    paymentPriceRowsView() {
      const showWarehouse = this.hasMultipleActiveWarehouses;
      return this.paymentPriceRows.map((row) =>
        row.key === "warehouse_id" ? { ...row, show: showWarehouse } : row
      );
    },
    selectionOptions() {
      if (this.selectionType === "country") {
        return this.deliveryNewCountryOptions;
      } else if (this.selectionType === "deliveryMethod") {
        return this.deliveryMethodOptions;
      } else if (this.selectionType === "deliveryMethodCountry") {
        return this.deliveryCountryOptions;
      } else if (this.selectionType === "deliveryMethodForCountry") {
        return this.deliveryMethodForCountryOptions;
      } else if (this.selectionType === "paymentMethod") {
        return this.paymentMethodOptions;
      }
      return [];
    },
    filteredSelectionOptions() {
      let options = this.selectionOptions;

      if (this.selectionTypeFilter) {
        options = options.filter(
          (option) => option.type === this.selectionTypeFilter
        );
      }

      if (!this.selectionSearch) {
        return options;
      }
      const search = this.selectionSearch.toLowerCase();
      return options.filter((option) => {
        return (
          option?.name?.toLowerCase().includes(search) ||
          option?.local_name?.toLowerCase().includes(search) ||
          option?.code?.toLowerCase().includes(search) ||
          option?.app_name?.toLowerCase().includes(search)
        );
      });
    },
    activeSelectionFilters() {
      const options = this.selectionOptions;
      if (!Array.isArray(options) || options.length === 0) return [];

      const types = new Set();
      options.forEach((opt) => {
        if (opt && opt.type !== undefined && opt.type !== null) {
          types.add(opt.type);
        }
      });

      return Array.from(types)
        .sort((a, b) => Number(a) - Number(b))
        .map((typeId) => ({
          id: typeId,
          name: this.$t(`webshops.deliveryTypes.${typeId}`),
        }));
    },
    paymentGroups() {
      const groups = [];
      for (const method of this.payment) {
        if (!method.active) {
          continue;
        }
        const group = {
          key: "payment_" + method.id,
          label: method.name,
          methodId: method.id,
          items: [],
        };
        for (const row of this.paymentPrices) {
          if (row.payment_method_id == method.id) {
            group.items.push(row);
          }
        }
        groups.push(group);
      }
      return groups;
    },
  },
  mounted() {
    this.load();
    if (Array.isArray(this.enabledCurrencies)) {
      this.setRowValues("currency_code", this.enabledCurrencies, true);
    }
    if (Array.isArray(this.countries)) {
      this.setRowValues("country_id", this.countries, true);
    }
    if (Array.isArray(this.warehouses)) {
      this.setRowValues("warehouse_id", this.warehouses);
    }
    this.loadPrices();
  },
  watch: {
    selectedSection() {
      this.loadPrices();
    },
    selectedWebshop: {
      deep: true,
      handler() {
        this.calcDelivery();
        this.calcPayments();
        this.loadPrices();
        this.deliveryAdder = null;
        this.paymentAdder = null;
        this.selectedDeliveryWebshop = null;
        this.selectedReturnWebshop = null;
        this.selectedDeliveryMethodId = this.deliveryMethodTabs[0]?.id ?? null;
        this.selectedDeliveryCountryId =
          this.deliveryCountryTabs[0]?.id ?? null;
        this.selectedPaymentMethodId = this.paymentMethodTabs[0]?.id ?? null;
        this.selectedPaymentCountryId = this.paymentCountryTabs[0]?.id ?? null;
      },
    },
    deliveryGrouping() {
      this.deliveryAdder = null;
    },
    paymentGrouping() {
      this.paymentAdder = null;
    },
    deliveryMethodToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryMethodToAdd = null;
      this.deliveryAdder = null;
      this.enableDeliveryMethod(id);
    },
    deliveryCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryCountryToAdd = null;
      this.deliveryAdder = null;
      this.addDeliveryCountry(id);
    },
    deliveryNewCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryNewCountryToAdd = null;
      this.deliveryAdder = null;
      this.selectedDeliveryCountryId = id;
    },
    deliveryMethodForCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryMethodForCountryToAdd = null;
      this.deliveryAdder = null;
      this.addDeliveryMethodToCountry(id);
    },
    paymentMethodToAdd(id) {
      if (!id) {
        return;
      }
      this.paymentMethodToAdd = null;
      this.paymentAdder = null;
      this.enablePaymentMethod(id);
    },
    paymentCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.paymentCountryToAdd = null;
      this.paymentAdder = null;
      this.addPaymentCountry(id);
    },
    paymentNewCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.paymentNewCountryToAdd = null;
      this.paymentAdder = null;
      this.selectedPaymentCountryId = id;
    },
    paymentMethodForCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.paymentMethodForCountryToAdd = null;
      this.paymentAdder = null;
      this.addPaymentMethodToCountry(id);
    },
    currencies(values) {
      if (!Array.isArray(values)) return;
      this.setRowValues("currency_code", values, true);
    },
    countries(values) {
      if (!Array.isArray(values)) return;
      this.setRowValues("country_id", values, true);
    },
    warehouses(values) {
      if (!Array.isArray(values)) return;
      this.setRowValues("warehouse_id", values);
    },
  },
  methods: {
    basicCol(field) {
      const webshop = {
        name: 5,
        domain: 4,
        slug: 3,
        currency: 3,
        company: 6,
        language: 3,
        email: 3,
        phone: 3,
        country: 3,
        returnDuration: 3,
      };
      const internal = {
        name: 6,
        currency: 3,
        email: 3,
        company: 3,
        language: 3,
        phone: 3,
        country: 3,
        returnDuration: 12,
      };
      const cols = this.isWebshopType ? webshop : internal;
      return "col-" + (cols[field] ?? 12) + " mb-3";
    },
    buildDeliverySection(method, country, label) {
      return {
        key: "c" + country.id + "m" + method.id,
        methodId: method.id,
        countryId: country.id,
        methodType: method.type,
        label,
        isAutomaticSelect: !!method.is_automatic_select,

        canAutoSelect: !method.is_automatic_select && method.type == 1,
        typeName: deliveryTypeValues[method.type]?.name ?? null,
        logo: this.methodLogoUrl(method.icon),
        items: this.deliveryPrices.filter(
          (row) =>
            row.delivery_method_id == method.id &&
            (row.country_id == country.id || (!row.country_id && !country.id))
        ),
      };
    },
    buildPaymentSection(method, label) {
      return {
        key: "pm" + method.id,
        methodId: method.id,
        countryId: null,
        label,
        logo: this.methodLogoUrl(method.icon),
        items: this.paymentPrices.filter(
          (row) => row.payment_method_id == method.id
        ),
      };
    },
    sectionRows(section) {
      const showPickup = section.methodType === 2;
      const showWarehouse = this.hasMultipleActiveWarehouses;
      return this.deliveryPriceRows.map((row) => {
        if (row.key === "delivery_point_type") {
          return { ...row, show: showPickup };
        }
        if (row.key === "warehouse_id") {
          return { ...row, show: showWarehouse };
        }
        return row;
      });
    },
    sectionApps(section) {
      const apps = this.deliveryApps[section.methodId];
      return Array.isArray(apps) ? apps : [];
    },
    sectionAppId(section) {
      if (section.items.length > 0) {
        return section.items[0].app_id ?? null;
      }
      const method = this.delivery.find((m) => m.id == section.methodId);
      return method?.app_id ?? null;
    },
    setSectionProvider(section, appId) {
      for (const row of section.items) {
        row.app_id = appId;
        if (row.price_id > 0) {
          http.fetch(
            "/deliveries/methods/" + row.price_id,
            { app_id: appId },
            true,
            "PUT"
          );
        }
      }
    },
    sectionAutoSelect(section) {
      return section.items.some((row) => !!row.auto_select);
    },
    toggleSectionAutoSelect(section) {
      const enable = !this.sectionAutoSelect(section);
      const endpoint = enable ? "enable-auto-select" : "disable-auto-select";
      http
        .fetch(
          "/couriers/" + endpoint,
          {
            delivery_method_id: section.methodId,
            country_id: section.countryId,
          },
          true
        )
        .then(() => {
          for (const row of section.items) {
            row.auto_select = enable ? 1 : 0;
          }
        });
    },
    methodLogoUrl(icon) {
      if (!icon) {
        return null;
      }
      if (icon.indexOf("http") !== 0 && icon.indexOf("//") !== 0) {
        return tenant.getAppFilesUrl() + "/" + icon;
      }
      return icon;
    },
    ordinal_suffix_of(i, asText = true) {
      if (asText && i < 10) {
        return this.columnNumbers[i];
      }
      i++;
      if (this.$i18n.locale !== "en") {
        return i + ".";
      }
      let j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + "st";
      }
      if (j === 2 && k !== 12) {
        return i + "nd";
      }
      if (j === 3 && k !== 13) {
        return i + "rd";
      }
      return i + "th";
    },
    openSelectionModal(type) {
      this.selectionType = type;
      this.selectionSearch = "";
      this.selectionTypeFilter = null;
      if (!this.selectionModal) {
        const bootstrap = require("bootstrap");
        this.selectionModal = new bootstrap.Modal(this.$refs.selectionModal, {
          backdrop: "static",
        });
        this.$refs.selectionModal.addEventListener("shown.bs.modal", () => {
          if (this.$refs.selectionSearchInput) {
            this.$refs.selectionSearchInput.focus();
          }
        });
      }
      this.selectionModal.show();
    },
    selectItem(item) {
      if (this.selectionType === "country") {
        this.selectedDeliveryCountryId = item.id;
        // Also add it to active countries if it's not already there
        if (!this.deliveryCountryTabs.some((c) => c.id === item.id)) {
          this.addDeliveryCountry(item.id);
        }
      } else if (this.selectionType === "deliveryMethod") {
        this.enableDeliveryMethod(item.id);
      } else if (this.selectionType === "deliveryMethodCountry") {
        this.addDeliveryCountry(item.id, this.selectedDeliveryMethodId);
      } else if (this.selectionType === "deliveryMethodForCountry") {
        this.addDeliveryMethodToCountry(item.id);
      } else if (this.selectionType === "paymentMethod") {
        this.enablePaymentMethod(item.id);
      }
      this.selectionModal.hide();
    },
    calcDelivery() {
      if (!Array.isArray(this.deliveries)) return;
      let rows = JSON.parse(JSON.stringify(this.deliveries));
      let rowRefs = {};
      for (const key in rows) {
        rowRefs[rows[key].id] = rows[key];
        rowRefs[rows[key].id].active = false;

        rowRefs[rows[key].id].countries = {
          active: [],
          all: Array.isArray(rowRefs[rows[key].id].supported_coutries)
            ? rowRefs[rows[key].id].supported_coutries
            : [],
        };
      }

      if (this.selectedWebshop?.id > 0) {
        const methods = Array.isArray(this.selectedWebshop.deliveryMethods)
          ? this.selectedWebshop.deliveryMethods
          : [];
        for (const method of methods) {
          if (rowRefs[method.id]) {
            rowRefs[method.id].active = true;
            let activeCountries = [];
            if (
              method.pivot?.countries !== undefined &&
              method.pivot?.countries !== null
            ) {
              activeCountries = Array.isArray(method.pivot.countries)
                ? method.pivot.countries
                : [];
            } else if (
              method.countries !== undefined &&
              method.countries !== null
            ) {
              activeCountries = Array.isArray(method.countries)
                ? method.countries
                : [];
            }
            for (const country of activeCountries) {
              const cId = typeof country === "object" ? country.id : country;
              if (
                cId &&
                rowRefs[method.id]?.countries?.active &&
                !rowRefs[method.id].countries.active.includes(cId)
              ) {
                rowRefs[method.id].countries.active.push(cId);
              }
            }
          }
        }
      }
      this.delivery = rows;
    },
    calcPayments() {
      if (!Array.isArray(this.payments)) return;
      let rows = JSON.parse(JSON.stringify(this.payments));
      let rowRefs = {};
      for (const key in rows) {
        rowRefs[rows[key].id] = rows[key];
        rowRefs[rows[key].id].active = false;
        // Payments use app_name directly from the object
        rowRefs[rows[key].id].app_name = rows[key].app_name;

        rowRefs[rows[key].id].countries = {
          active: [],
          all: Array.isArray(rowRefs[rows[key].id].supported_countries)
            ? rowRefs[rows[key].id].supported_countries
            : [],
        };
      }

      if (this.selectedWebshop?.id > 0) {
        const methods = Array.isArray(this.selectedWebshop.paymentMethods)
          ? this.selectedWebshop.paymentMethods
          : [];
        for (const method of methods) {
          if (rowRefs[method.id]) {
            rowRefs[method.id].active = true;
            let activeCountries = [];
            if (
              method.pivot?.countries !== undefined &&
              method.pivot?.countries !== null
            ) {
              activeCountries = Array.isArray(method.pivot.countries)
                ? method.pivot.countries
                : [];
            } else if (
              method.countries !== undefined &&
              method.countries !== null
            ) {
              activeCountries = Array.isArray(method.countries)
                ? method.countries
                : [];
            }
            for (const country of activeCountries) {
              const cId = typeof country === "object" ? country.id : country;
              if (
                cId &&
                rowRefs[method.id]?.countries?.active &&
                !rowRefs[method.id].countries.active.includes(cId)
              ) {
                rowRefs[method.id].countries.active.push(cId);
              }
            }
          }
        }
      }
      this.payment = rows;
    },
    setRowValues(key, values, both = false) {
      const deliveryRow = this.deliveryPriceRows.find((r) => r.key === key);
      if (deliveryRow) {
        deliveryRow.values = values;
      }
      if (both) {
        const paymentRow = this.paymentPriceRows.find((r) => r.key === key);
        if (paymentRow) {
          paymentRow.values = values;
        }
      }
    },
    loadPrices() {
      if (!this.selectedWebshop?.id || this.loadInProcess) {
        return;
      }
      this.loadInProcess = true;
      http
        .fetch("/webshops/" + this.selectedWebshop.id + "/prices")
        .then((data) => {
          this.deliveryPrices = data.delivery_prices || [];
          this.paymentPrices = data.payment_prices || [];
          this.key++;
          this.loadInProcess = false;
        })
        .catch(() => {
          this.loadInProcess = false;
        });
    },
    deliveryRowComplete(row) {
      return (
        row.delivery_method_id > 0 &&
        row.country_id &&
        row.currency_code &&
        row.price !== undefined &&
        row.price !== ""
      );
    },
    createChannelDeliveryPrice(row) {
      const data = {
        delivery_method_id: row.delivery_method_id,
        country_id: row.country_id,
        currency_code: row.currency_code,
        price: row.price,
        min_order_amount: row.min_order_amount ?? null,
        min_order_count: row.min_order_count ?? null,
        warehouse_id: row.warehouse_id ?? null,
        delivery_point_type: row.delivery_point_type ?? null,
        is_delivery: row.is_delivery ?? null,
        is_return: row.is_return ?? null,
        app_id: row.app_id ?? null,
        webshop_id: this.selectedWebshop.id,
      };
      this.disabled = true;
      http
        .fetch(
          "/deliveries/methods",
          data,
          true,
          "POST",
          "Creating new price.."
        )
        .then((res) => {
          this.disabled = false;
          row.price_id = res.id;
          row.has_delivery = res.has_delivery;
          row.has_return = res.has_return;
          row.is_change = res.is_change;
          row.is_home_delivery = res.is_home_delivery;
          this.key++;
        });
    },
    updateDeliveryPrice(row, key, val) {
      if (key === "delivery_method_id") {
        row["type"] = this.deliveries.find((e) => e.id === val)?.type;
      }

      if (row.price_id > 0) {
        const send = {};
        send[key] = val;
        http.fetch("/deliveries/methods/" + row.price_id, send, true, "PUT");
        return;
      }
      if (this.deliveryRowComplete(row)) {
        this.createChannelDeliveryPrice(row);
      }
    },
    addDeliveryPrice(section, key, val) {
      if (val === undefined || val === "") {
        return;
      }
      let row = this.deliveryPrices.find(
        (r) =>
          r.price_id === 0 &&
          r.delivery_method_id == section.methodId &&
          r.country_id == section.countryId
      );
      if (!row) {
        row = {
          price_id: 0,
          delivery_method_id: section.methodId,
          country_id: section.countryId,
          currency_code: this.selectedWebshop?.currency_code,
        };
        const method = this.deliveries.find((e) => e.id == section.methodId);
        if (method) {
          row.is_delivery = method.is_delivery;
          row.is_return = method.is_return;
          row.type = method.type;
        }
        this.deliveryPrices.push(row);
      }
      row[key] = val;
      if (this.deliveryRowComplete(row)) {
        this.createChannelDeliveryPrice(row);
      }
    },
    deleteDeliveryPrice(row) {
      if (!row.price_id) {
        const index = this.deliveryPrices.indexOf(row);
        if (index > -1) {
          this.deliveryPrices.splice(index, 1);
        }
        return;
      }
      this.deleteItem = row;
      this.deleteType = "deliveryPrice";
      this.$refs.deleteModal.showModal();
    },
    paymentRowComplete(row) {
      return (
        row.payment_method_id > 0 &&
        row.currency_code &&
        row.price !== undefined &&
        row.price !== ""
      );
    },
    createChannelPaymentPrice(row) {
      const data = {
        payment_method_id: row.payment_method_id,
        country_id: row.country_id,
        currency_code: row.currency_code,
        price: row.price,
        min_order_amount: row.min_order_amount ?? null,
        min_order_count: row.min_order_count ?? null,
        warehouse_id: row.warehouse_id ?? null,
        webshop_id: this.selectedWebshop.id,
      };
      this.disabled = true;
      http
        .fetch("/payments/methods", data, true, "POST", "Creating new price..")
        .then((res) => {
          this.disabled = false;
          row.price_id = res.id;
          this.key++;
        });
    },
    updatePaymentPrice(row, key, val) {
      if (row.price_id > 0) {
        const send = {};
        send[key] = val;
        http.fetch("/payments/methods/" + row.price_id, send, true, "PUT");
        return;
      }
      if (this.paymentRowComplete(row)) {
        this.createChannelPaymentPrice(row);
      }
    },
    addPaymentPrice(section, key, val) {
      if (val === undefined || val === "") {
        return;
      }
      let row = this.paymentPrices.find(
        (r) => r.price_id === 0 && r.payment_method_id == section.methodId
      );
      if (!row) {
        row = {
          price_id: 0,
          payment_method_id: section.methodId,
          country_id: null,
          currency_code: this.selectedWebshop?.currency_code,
        };
        this.paymentPrices.push(row);
      }
      row[key] = val;
      if (key === "currency_code") {
        row["price"] = 0;
      }
      if (this.paymentRowComplete(row)) {
        this.createChannelPaymentPrice(row);
      }
    },
    deletePaymentPrice(row) {
      if (!row.price_id) {
        const index = this.paymentPrices.indexOf(row);
        if (index > -1) {
          this.paymentPrices.splice(index, 1);
        }
        return;
      }
      this.deleteItem = row;
      this.deleteType = "paymentPrice";
      this.$refs.deleteModal.showModal();
    },
    deletePrice() {
      const endpoint =
        this.deleteType === "deliveryPrice"
          ? "/deliveries/methods/"
          : "/payments/methods/";
      http
        .fetch(endpoint + this.deleteItem.price_id, {}, true, "DELETE")
        .then(() => {
          const list =
            this.deleteType === "deliveryPrice"
              ? this.deliveryPrices
              : this.paymentPrices;
          const index = list.indexOf(this.deleteItem);
          if (index > -1) {
            list.splice(index, 1);
          }
          this.deleteItem = null;
          this.key++;
        });
    },
    load() {
      Promise.all([
        http.fetch("/webshops?hide-global-payments=1"),
        http.fetch("/deliveries/methods/"),
        http.fetch("/payments/methods/"),
        http.fetch("/domains"),
      ]).then(([webshops, deliveries, payments, domainData]) => {
        this.webshops = webshops;
        this.domains = domainData?.domains ?? [];
        this.deliveries = deliveries;
        this.payments = payments;
        this.calcDelivery();
        this.calcPayments();
        if (this.webshops.length > 0) {
          this.selectedWebshop = this.webshops[0];
          this.normalizeSupportedLanguages(this.selectedWebshop);
          this.loadPrices();
        } else {
          this.selectedWebshop = {};
        }
      });
      http.fetch("/companies").then((data) => {
        this.companies = data;
      });
      http.fetch("/deliveries/apps").then((data) => {
        this.deliveryApps = data;
        this.calcDelivery();
      });
    },
    setType(value) {
      if (
        value === 1 &&
        !Array.isArray(this.selectedWebshop.supported_languages)
      ) {
        this.selectedWebshop.supported_languages = [];
      }
      this.selectedWebshop.type = value;
    },
    toggleSupportedLanguage(code, checked) {
      const current = this.supportedLanguages;
      this.selectedWebshop.supported_languages = checked
        ? [...new Set([...current, code])]
        : current.filter((c) => c !== code);
    },
    parseLanguages(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string" && value.length > 0) {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (e) {
          return value.split(",");
        }
      }
      return [];
    },
    normalizeSupportedLanguages(webshop) {
      webshop.supported_languages = this.parseLanguages(
        webshop.supported_languages
      );
    },
    saveBasic() {
      if (this.basicSaving) {
        return;
      }
      let data = Object.assign({}, this.selectedWebshop);
      delete data.paymentMethods;
      delete data.deliveryMethods;
      delete data.country;
      delete data.deliveryWarehouses;
      delete data.returnWarehouses;
      data.is_return = data.is_return ? 1 : 0;
      data.is_change = data.is_change ? 1 : 0;
      data.is_international_cod = data.is_international_cod ? 1 : 0;
      data.is_group_delivery_methods = data.is_group_delivery_methods ? 1 : 0;
      data.use_default_language = data.use_default_language ? 1 : 0;
      data.type = data.type ?? 1;
      data.supported_languages = Array.isArray(data.supported_languages)
        ? data.supported_languages
        : [];

      this.basicSaving = true;
      if (this.selectedWebshop.id) {
        http
          .fetch("/webshops/" + this.selectedWebshop.id, data, true, "PUT")
          .then(() => {
            this.basicSaving = false;
          })
          .catch(() => {
            this.basicSaving = false;
          });
      } else {
        http
          .fetch("/webshops", data, true)
          .then((created) => {
            this.basicSaving = false;
            if (!created?.id) {
              return;
            }
            Object.assign(created, {
              deliveryMethods: [],
              paymentMethods: [],
              deliveryWarehouses: [],
              returnWarehouses: [],
              country: null,
            });
            this.webshops.push(created);
            this.selectedWebshop = created;
          })
          .catch(() => {
            this.basicSaving = false;
          });
      }
    },
    saveDeliveryPivots() {
      if (!this.selectedWebshop?.id) {
        return;
      }
      if (this.deliverySaving) {
        this.deliverySaveQueued = true;
        return;
      }
      const data = {
        deliveries: [],
      };
      for (const method of this.delivery) {
        if (method.active) {
          data.deliveries.push({
            id: method.id,
            countries: method.countries?.active ?? [],
          });
        }
      }
      this.deliverySaving = true;
      http
        .fetch(
          "/webshops/" + this.selectedWebshop.id + "/deliveries",
          data,
          true
        )
        .then(() => {
          this.deliverySaving = false;
          if (this.deliverySaveQueued) {
            this.deliverySaveQueued = false;
            this.saveDeliveryPivots();
          }
        });
    },
    enableDeliveryMethod(id) {
      const method = this.delivery.find((m) => m.id == id);
      if (!method) {
        return;
      }
      method.active = true;
      this.selectedDeliveryMethodId = method.id;
      this.saveDeliveryPivots();
    },
    disableDeliveryMethod(method) {
      method.active = false;
      if (method.id == this.selectedDeliveryMethodId) {
        this.selectedDeliveryMethodId = this.deliveryMethodTabs[0]?.id ?? null;
      }
      this.saveDeliveryPivots();
    },
    addDeliveryCountry(countryId) {
      const method = this.selectedDeliveryMethod;
      if (!method || method.countries.active.some((id) => id == countryId)) {
        return;
      }
      method.countries.active.push(countryId);
      this.saveDeliveryPivots();
    },
    removeDeliveryCountry(method, countryId) {
      const index = method.countries.active.findIndex((id) => id == countryId);
      if (index === -1) {
        return;
      }
      method.countries.active.splice(index, 1);
      this.saveDeliveryPivots();
    },
    disableDeliveryCountry(countryId) {
      for (const method of this.delivery) {
        if (!method.active) {
          continue;
        }
        const index = method.countries.active.findIndex(
          (id) => id == countryId
        );
        if (index > -1) {
          method.countries.active.splice(index, 1);
        }
      }
      if (this.selectedDeliveryCountryId == countryId) {
        this.selectedDeliveryCountryId =
          this.deliveryCountryTabs[0]?.id ?? null;
      }
      this.saveDeliveryPivots();
    },
    addDeliveryMethodToCountry(methodId) {
      const method = this.delivery.find((m) => m.id == methodId);
      if (!method) {
        return;
      }
      if (!method.active) {
        method.active = true;
      }
      if (
        !method.countries.active.some(
          (id) => id == this.selectedDeliveryCountryId
        )
      ) {
        method.countries.active.push(this.selectedDeliveryCountryId);
      }
      this.saveDeliveryPivots();
    },
    enablePaymentMethod(id) {
      const method = this.payment.find((m) => m.id == id);
      if (!method) {
        return;
      }
      method.active = true;
      this.selectedPaymentMethodId = method.id;
      this.savePaymentPivots();
    },
    disablePaymentMethod(method) {
      method.active = false;
      if (method.id == this.selectedPaymentMethodId) {
        this.selectedPaymentMethodId = this.paymentMethodTabs[0]?.id ?? null;
      }
      this.savePaymentPivots();
    },
    addPaymentCountry(countryId) {
      const method = this.selectedPaymentMethod;
      if (!method || method.countries.active.some((id) => id == countryId)) {
        return;
      }
      method.countries.active.push(countryId);
      this.savePaymentPivots();
    },
    removePaymentCountry(method, countryId) {
      const index = method.countries.active.findIndex((id) => id == countryId);
      if (index === -1) {
        return;
      }
      method.countries.active.splice(index, 1);
      this.savePaymentPivots();
    },
    disablePaymentCountry(countryId) {
      for (const method of this.payment) {
        if (!method.active) {
          continue;
        }
        const index = method.countries.active.findIndex(
          (id) => id == countryId
        );
        if (index > -1) {
          method.countries.active.splice(index, 1);
        }
      }
      if (this.selectedPaymentCountryId == countryId) {
        this.selectedPaymentCountryId = this.paymentCountryTabs[0]?.id ?? null;
      }
      this.savePaymentPivots();
    },
    addPaymentMethodToCountry(methodId) {
      const method = this.payment.find((m) => m.id == methodId);
      if (!method) {
        return;
      }
      if (!method.active) {
        method.active = true;
      }
      if (
        !method.countries.active.some(
          (id) => id == this.selectedPaymentCountryId
        )
      ) {
        method.countries.active.push(this.selectedPaymentCountryId);
      }
      this.savePaymentPivots();
    },
    savePaymentPivots() {
      if (!this.selectedWebshop?.id) {
        return;
      }
      const data = {
        payments: [],
      };
      for (const method of this.payment) {
        if (method.active) {
          data.payments.push({
            id: method.id,
            countries: method.countries?.active ?? [],
          });
        }
      }
      http
        .fetch("/webshops/" + this.selectedWebshop.id + "/payments", data, true)
        .then(() => {
          this.loadPrices();
        });
    },
    savePayment() {
      this.savePaymentPivots();
    },
    saveWarehouses() {
      let data = {
        delivery: [],
        return: [],
      };

      for (const warehouse of this.selectedWebshop.deliveryWarehouses) {
        data.delivery.push(warehouse.id);
      }
      for (const warehouse of this.selectedWebshop.returnWarehouses) {
        data.return.push(warehouse.id);
      }

      http.fetch(
        "/webshops/" + this.selectedWebshop.id + "/warehouses",
        data,
        true
      );
    },
    addWarehouse(type) {
      let e = null;
      let webshop = null;
      if (type === "delivery") {
        e = this.selectedWebshop.deliveryWarehouses;
        webshop = this.selectedDeliveryWebshop;
      } else if (type === "return") {
        e = this.selectedWebshop.returnWarehouses;
        webshop = this.selectedReturnWebshop;
      }
      if (!e || !webshop) {
        return;
      }
      if (e.some((w) => w.id == webshop.id)) {
        return;
      }
      e.push({ id: webshop.id, name: webshop.name });
      if (type === "delivery") {
        this.selectedDeliveryWebshop = null;
      } else {
        this.selectedReturnWebshop = null;
      }
    },
    deleteWarehouse(type, id) {
      let e = null;
      if (type === "delivery") {
        e = this.selectedWebshop.deliveryWarehouses;
      } else if (type === "return") {
        e = this.selectedWebshop.returnWarehouses;
      }
      if (!e) {
        return;
      }
      const index = e.findIndex((i) => i.id == id);
      if (index === -1) {
        return;
      }
      e.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.delivery-add-select {
  display: inline-block;
  width: 240px;
  vertical-align: middle;
}
.section-provider-select {
  display: inline-block;
  width: 200px;
  vertical-align: middle;
}
.auto-select-check {
  height: 28px;
  padding-left: 30px;
}
.removable-badge,
.tab-removable {
  position: relative;
}
.removable-badge {
  cursor: default;
}
.removable-badge .remove-x,
.tab-removable .remove-x {
  display: none;
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  color: var(--gray-dark, #343a40);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.removable-badge:hover .remove-x,
.tab-removable:hover .remove-x {
  display: inline-flex;
}
.removable-badge .remove-x:deep(svg),
.tab-removable .remove-x:deep(svg) {
  width: 12px;
  height: 12px;
}
.removable-badge .remove-x:hover,
.tab-removable .remove-x:hover {
  color: #af0f0f;
}
.btn-main-method-list {
  padding: 0.4em 0.3em;
  font-size: 0.8em;
  max-width: 7em;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 4em;
}
.group-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin-top: 8px;
}
.group-option {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e5e9ed;
  border-radius: 10px;
  background: #f8fafb;
  text-align: left;
  transition: all 0.2s ease;
}
.group-option:hover {
  border-color: #b9cddf;
  background: #fff;
}
.group-option.active {
  border-color: #2878d4;
  background: #eef5fd;
  box-shadow: 0 2px 8px rgba(40, 120, 212, 0.1);
}
.group-option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 86px;
  flex: none;
  border-radius: 8px;
  background: #fff;
  color: #71808a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.group-option-icon svg {
  width: 100%;
}
.group-option.active .group-option-icon {
  background: #2878d4;
  color: #fff;
}
.group-option-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.group-option-label {
  color: #263238;
  font-size: 0.95rem;
  font-weight: 700;
}
.group-option-description {
  color: #71808a;
  font-size: 0.82rem;
  line-height: 1.3;
}
.group-option.active .group-option-label {
  color: #2878d4;
}
.group-option.small {
  padding: 8px 12px;
  gap: 8px;
}
.group-option-icon.small {
  width: 32px;
  height: 32px;
}
.group-option-label.small {
  font-size: 0.85rem;
}
.help-text {
  display: block;
  font-size: 0.75rem;
  color: #71808a;
  margin-top: 4px;
  font-weight: normal;
}
.selection-list {
  max-height: 60vh;
  overflow-y: auto;
}
.selection-item {
  transition: background-color 0.2s;
  cursor: pointer;
}
.selection-item:hover {
  background-color: #f8fafb;
}
.method-logo-lg {
  max-width: 48px;
  max-height: 48px;
  object-fit: contain;
}
.method-logo-sm {
  max-width: 20px;
  max-height: 20px;
  object-fit: contain;
}
.method-logo-placeholder {
  width: 48px;
  height: 48px;
  background-color: #eef5fd;
  color: #2878d4;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: bold;
}

.bg-success-subtle {
  background-color: #d1e7dd;
}
.text-success {
  color: #0f5132 !important;
}
.border-success-subtle {
  border-color: #badbcc;
}

.bg-info-subtle {
  background-color: #cff4fc;
}
.text-info {
  color: #055160 !important;
}
.border-info-subtle {
  border-color: #b6effb;
}

.bg-warning-subtle {
  background-color: #fff3cd;
}
.text-warning {
  color: #664d03 !important;
}
.border-warning-subtle {
  border-color: #ffecb5;
}

.bg-danger-subtle {
  background-color: #f8d7da;
}
.text-danger {
  color: #842029 !important;
}
.border-danger-subtle {
  border-color: #f5c2c7;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}
</style>
